import { useRouteTracking } from '@/lib/hooks/tracking';

const RouteTracker = () => {
  useRouteTracking();

  return null;
};

export default RouteTracker;
